import { render } from "./EventSummary.vue?vue&type=template&id=3978e9cf&scoped=true"
import script from "./EventSummary.vue?vue&type=script&lang=js"
export * from "./EventSummary.vue?vue&type=script&lang=js"

import "./EventSummary.vue?vue&type=style&index=0&id=3978e9cf&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3978e9cf"]])

export default __exports__